import { Button, Snackbar } from '@tunasong/ui-lib'
import type { FC } from 'react'
import { useState } from 'react'

export interface UndoSnackbarProps {
  message: string
  onUndo(): void
  onClose(): void
}

/** At least 6 s, per WCAG 2.2.1: and never while the pointer or keyboard focus is on it. */
const visibleMs = 6000

/** "Removed Kick." with Undo, announced politely. Deletes never ask for confirmation; this is the safety net. */
export const UndoSnackbar: FC<UndoSnackbarProps> = props => {
  const { message, onUndo, onClose } = props
  const [focused, setFocused] = useState(false)
  const [hovered, setHovered] = useState(false)
  return (
    <Snackbar
      open
      message={message}
      autoHideDuration={focused || hovered ? null : visibleMs}
      onClose={onClose}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      action={
        <Button color="inherit" onClick={onUndo}>
          Undo
        </Button>
      }
    />
  )
}

export default UndoSnackbar
